var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"id":"exercise"}},[(_vm.animations.length > 0)?_c('ExerciseAnimation',{attrs:{"animations":_vm.animations},on:{"finished":function($event){return _vm.onFinished()}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }